import React from "react";

import { CARDS_PER_ROW } from "@/components/Search/constants";
import { MobileShowAllResultsButtonProps } from "../types";

function MobileShowAllResultsButton({
  handleTabClick,
  results,
  title,
  cardsPerRow = CARDS_PER_ROW,
}: MobileShowAllResultsButtonProps) {
  return (
    <div className="flex justify-center lg:hidden">
      <button
        onClick={handleTabClick}
        className="flex items-center bg-info-300 rounded-xl border shadow text-primary text-xl h-[332px] w-[270px] px-8 text-center whitespace-normal hover:bg-info-400 transition-colors"
      >
        <span>{`Show ${(results?.nbHits || 0) > cardsPerRow ? "all" : ""} ${results?.nbHits || 0} ${title.toLocaleLowerCase()}`}</span>
      </button>
    </div>
  );
}

export default MobileShowAllResultsButton;
